/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Level2OuterPageLoading } from "@octopusdeploy/design-system-components";
import type { Repository, RunbookSnapshotResource } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import type * as React from "react";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/index";
import { DataBaseComponent } from "~/components/DataBaseComponent/index";
import { createErrorInfoFromErrors } from "~/components/PageContent/createErrorInfo";
import { repository } from "../../clientInstance";
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
interface ProjectRunbookChildRedirectState extends DataBaseComponentState {
    redirectTo: LinkHref;
}
interface ProjectRunbookChildRedirectProps {
    spaceId: string;
    getRunbookSnapshot: (repository: Repository) => Promise<RunbookSnapshotResource>;
    getRedirectPath: (projectId: string, runbookId: string) => LinkHref;
}
class ProjectRunbookChildRedirect extends DataBaseComponent<ProjectRunbookChildRedirectProps, ProjectRunbookChildRedirectState> {
    constructor(props: ProjectRunbookChildRedirectProps) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const runbookSnapshot = await this.props.getRunbookSnapshot(repository);
            const redirectTo = this.props.getRedirectPath(runbookSnapshot.ProjectId, runbookSnapshot.RunbookId);
            this.setState({
                redirectTo,
            });
        });
    }
    render() {
        const redirectTo = this.state.redirectTo;
        const errorInfo = this.errors ? createErrorInfoFromErrors(this.errors) : undefined;
        if (!redirectTo) {
            return (<main>
                    <Level2OuterPageLoading errors={errorInfo}/>
                </main>);
        }
        return <InternalRedirect push={false} to={redirectTo}/>;
    }
    static displayName = "ProjectRunbookChildRedirect";
}
export const RunbookSnapshotRedirect: React.FC<{
    spaceId: string;
    runbookSnapshotId: string;
}> = (props) => {
    return (<ProjectRunbookChildRedirect spaceId={props.spaceId} getRunbookSnapshot={(r) => r.RunbookSnapshots.get(props.runbookSnapshotId)} getRedirectPath={(projectId: string, runbookId: string) => links.runbookSnapshotPage.generateUrl({ spaceId: props.spaceId, projectSlug: projectId, runbookId, runbookSnapshotId: props.runbookSnapshotId })}/>);
};
RunbookSnapshotRedirect.displayName = "RunbookSnapshotRedirect"
